import { useContext, useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

import ProductCard from "../../components/product-card/product-card.component";
import AnimationPage from "../../components/smallcomponents/animation.component";

import { CategoriesContext } from "../../contexts/categories.context";

import { CategoryContainer, IInContainer, Title } from "./category.styles";

const Category = () => {
  let catRef = useRef(false);
  const { category } = useParams();
  const { categoriesMap } = useContext(CategoriesContext);
  const [products, setProducts] = useState(categoriesMap[category]);

  useEffect(() => {
    if (catRef.current === true) {
      setProducts(categoriesMap[category]);
    }

    return () => {
      catRef.current = true;
    };
  }, [category, categoriesMap]);

  return (
    <AnimationPage>
      <Title>{category.toUpperCase()}</Title>
      <CategoryContainer>
        <IInContainer>
          {products &&
            products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
        </IInContainer>
      </CategoryContainer>
    </AnimationPage>
  );
};

export default Category;
